import styled from 'styled-components';

const Form = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

const FormItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const ModalSubTitleWrapper = styled.div`
  display: flex;
`;

export { Form, FormItem, ModalSubTitleWrapper };
